import styles from 'NotFound.module.scss';

function NotFound() {
  return <div>NotFound</div>;
}

export default NotFound;
